import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageBrand } from "../../../components/MasterSettings/Brand/ManageBrand";
export const BrandManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageBrand />
        </div>
      </div>
    </div>
  );
};